var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F9EDD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8738 9.78858C14.8738 12.1192 13.748 13.5018 12.0099 13.5018C10.1335 13.5018 9.04717 12.1785 9.04717 9.78858C9.04717 7.22091 10.0742 5.89758 11.9506 5.89758C13.827 5.89758 14.8935 7.24066 14.8738 9.78858ZM5.5907 21.0073H9.02742V14.4104C9.89647 15.7139 11.2593 16.3855 12.9579 16.3855C16.0589 16.3855 18.4093 13.7586 18.4093 9.63056C18.4093 5.62106 16.1181 2.99414 12.9184 2.99414C11.2001 2.99414 9.99523 3.66569 8.96816 5.12728V3.42867H5.5907V21.0073Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofpoint);
export default __webpack_public_path__ + "static/media/Proofpoint.78589b0598980cf77b7eabd6413bf1c3.svg";
export { ForwardRef as ReactComponent };